import {call, put, takeLatest, debounce} from "redux-saga/effects";
import {receiptActions} from "./receiptSlice";
import {receiptApi} from "~/api";

function* fetchReceiptList(action) {
	try {
		const response = yield call(receiptApi.gets, action.payload);
		yield put(receiptActions.fetchDataSuccess(response))
	}
	catch (error) {
		console.log('Failed to fetch receipt list', error);
		yield put(receiptActions.fetchDataFailed(error.message));
	}
}

function* handleSearchDebounce(action) {
	yield put(receiptActions.setFilter(action.payload));
}

export default function* receiptSaga() {
	yield takeLatest(receiptActions.fetchData.type, fetchReceiptList);
	yield debounce(500, receiptActions.setFilterWithDebounce.type, handleSearchDebounce)
}

